module.exports = __webpack_public_path__ + "img/clqp.0803d42b.png";